/**
 * LiveCanvasPage — /live/:roomId, the target of a DeskeyPaint / DeskeyChart
 * "Go Live" share link. Opens the right canvas already joined to the room,
 * so another device (teacher or student) can follow along from any page.
 * Joiners don't get "Save to Section" — saving stays with the host's editor.
 */
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import DeskeyPaint from '@/components/DeskeyPaint';
import DeskeyChart from '@/components/DeskeyChart';
import { canvasKindOf } from '@/lib/collabRoom';

export default function LiveCanvasPage() {
  const { roomId } = useParams();
  const navigate = useNavigate();
  const kind = canvasKindOf(roomId);

  const leave = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate('/', { replace: true });
  };

  if (kind === 'paint') return <DeskeyPaint roomId={roomId} onClose={leave} />;
  if (kind === 'chart') return <DeskeyChart roomId={roomId} onClose={leave} />;

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="max-w-sm text-center" data-testid="live-canvas-invalid">
        <h1 className="text-lg font-bold text-slate-800">This live link isn't valid</h1>
        <p className="text-sm text-slate-500 mt-2">Ask the presenter to copy the live link again from Desky Paint or Desky Chart.</p>
        <button onClick={() => navigate('/', { replace: true })}
          className="mt-4 h-9 px-4 text-sm font-semibold text-white rounded-lg bg-[#34A853] hover:bg-[#2d9249]">
          Go home
        </button>
      </div>
    </div>
  );
}
